import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppState, Openable } from '../stores/appStateStore';
import { action } from 'mobx';
import { AppProps } from './App';

interface FolderProps extends AppProps {
    name: string;
    path: string;
    fileIx: number;
    indentationLevel: number;
    hasChildren: boolean;
    numberOfEmails: number;
    openable?: Openable;
    iconClass: string;
    eject?: () => void;
}

export const generateFileOrLabelTable = action( async (state: AppState, isOnlyFile: boolean, fileIx: number, path: string, name: string ) => {
    state.updateCurrentView('messageList');
    state.messageQueryAndIxList.fileIx = fileIx;
    state.sorting = {column: 'none', direction: 'asc', page: 0}; // Reset the column sorting

    let label;
    if(isOnlyFile) {
        state.messageQueryAndIxList.label = label = '';
    } else {
        state.messageQueryAndIxList.label = label = path + (path !== ''?'/':'') + name;
    }
    const currentFile = state.mboxList[fileIx];

    let indexList: number[] | undefined;
    if(label.length > 0) {
        indexList = currentFile.labelMetadata?.labelIndices.get(label);
        if(!indexList) {
            indexList = [];
        }
    } else {
        indexList = [];
        for(let i = 0; i < currentFile.messageData.length; i++) {
            indexList.push(i);
        }
    }
    state.messageQueryAndIxList.messageIxList = indexList;
    state.messageQueryAndIxList.filteredIxList = [...indexList];
}); // generateFileOrLabelTable()

// This component is explicitly not a folder and its contents, but only the one row on the table, as
//   determined by the information necessary to render it and the things it must affect.
// Instead of controlling state directly we inherit the relevant information and controls from our parent.
const Folder = observer((props: FolderProps) => {
    const {state, path, fileIx, name, indentationLevel, hasChildren, numberOfEmails, openable, iconClass, eject} = props;
    const labelCapitalization = state.mboxList[fileIx].labelMetadata?.labelCapitalization;
    return (
        <div className="folder prevent-select flex-mother" onClick={action(e => {
            // !!eject here is used to determine whether the Folder calling this is a full file or merely a label
            generateFileOrLabelTable(state, !!eject, fileIx, path, name);
        })}>
            <div className={'ml-' + indentationLevel + 'em p-3px' + (indentationLevel>0?' bl-1px-thl':'')} />
            {hasChildren && openable?
                <div className="flex-mother-col">
                    <div className="flex-1" />
                    <button className="navbarButton-half" onClick={action(e => {e.stopPropagation(); openable.isOpen = !openable.isOpen;})}><i className={openable.isOpen? 'arrow-down':'arrow-right'} /></button>
                    <div className="flex-1" />
                </div>
            : <div className="ml-1em h-navbarButton-half"/> }
            <div>
                <div className="flex-mother-col fill">
                    <div className="flex-1" />
                    <i className={iconClass} />
                    <div className="flex-1" />
                </div>
            </div>
            <div className="flex-1">
                <div className="flex-mother-col fill pl-5px">
                    <div className="flex-1" />
                    <div>{labelCapitalization&&!eject? labelCapitalization.get(name):name}</div>
                    <div className="flex-1" />
                </div>
            </div>
            <div className="flex-mother-col">
                <div className="flex-1" />
                <div>{numberOfEmails}</div>
                <div className="flex-1" />
            </div>
            {eject !== undefined? <button className="navbarButton-half" title="Unload file" onClick={action(e => {e.stopPropagation(); eject();})}><i className="eject-icon"/></button>:''}
        </div>
    );
});

export default Folder;